<template>
  <!--
    CR-03 (doc 28 §17/§18) -- the canonical prototype's zero-credit warning
    (`.chat-credit-warning`, design-reference/BORNA_final405-07-06.html),
    rendered in the Composer's `notice` slot (right above the composer) while
    the known balance is 0. Values measured from the rendered prototype at
    1440 / 390 / 360.

    Approved V1 deviations: the second line is the approved V1 copy, and there
    is no button -- no plans, payment, recharge or purchase exist in V1.
  -->
  <div
    class="ai-tutor-credit-warning"
    role="status"
    data-testid="ai-tutor-credit-warning"
  >
    <student-home-icon name="coin" :size="22" />
    <span class="ai-tutor-credit-warning__copy">
      <strong>{{ $t('aiTutorSetup.credits.exhaustedTitle') }}</strong>
      <small>{{ $t('aiTutorSetup.credits.exhaustedBody') }}</small>
    </span>
  </div>
</template>

<script>
import StudentHomeIcon from '@/components/StudentHome/StudentHomeIcon.vue'

export default {
  name: 'ChatCreditWarning',
  components: { StudentHomeIcon },
}
</script>

<style lang="scss" scoped>
// Rendered in the composer's `notice` slot: that area spaces it from the
// composer (the prototype's 8px), and it spans the composer's full width.
.ai-tutor-credit-warning {
  display: flex;
  align-items: center;
  gap: 10px;
  box-sizing: border-box;
  justify-self: stretch;
  width: 100%;
  margin: 0;
  padding: 10px 12px;
  border: 1px solid #f0d788;
  border-radius: 13px;
  background: #fff9e8;
  color: #725500;
  font-size: 14px;
  line-height: 1.75;

  svg {
    flex-shrink: 0;
  }
}

.ai-tutor-credit-warning__copy {
  display: grid;
  flex: 1;
  gap: 2px;

  strong {
    font-size: 14px;
    font-weight: 700;
  }

  small {
    color: #806d33;
    font-size: 11px;
    line-height: 1.75;
  }
}

// The prototype's phone tier (<=620px): items stretch, so the icon sits at the
// top of the text block instead of its centre.
@include borna-phone {
  .ai-tutor-credit-warning {
    flex-wrap: wrap;
    align-items: stretch;
  }
}
</style>
